export const relocateProductsInAudit = {
  hasDisabledInput: (): boolean => false,
  columns: [
    {
      title: "Jaba",
      name: "containerCode",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.containerCode,
    },
    {
      title: "Despacho",
      name: "serialNumber",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.serialNumber,
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.skuCode,
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.description
    },
    {
      title: 'Cant. Total',
      name: 'amountAttended',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.amountAttended
    },
    {
      title: "Cant. A reubicar",
      name: "amountToMove",
      type: "number",
      editable: true,
      align: "center",
      placeholderHidden: true,
      value: (element: any) => {
        return {
          num: element.amountToMove,
          min: 1,
          max: element.amountToMove,
        };
      },
    },
  ]
};
